import { render, staticRenderFns } from "./loginWithSSO.vue?vue&type=template&id=7b663840&"
import script from "./loginWithSSO.vue?vue&type=script&lang=ts&"
export * from "./loginWithSSO.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports